import React from "react";
import { AiOutlineAndroid, AiOutlineApple } from "react-icons/ai";
import Text from "../common/Text";
import Title from "../common/Title";

const DownloadApp = ({ android, ios, className }) => {
    return (
        <>
            <section className={`${className}`}>
                <div className="container py-20 lg:px-0">
                    <Title className="text-center">
                        ¿Cómo descargar la aplicación?
                    </Title>
                    <Text className="text-center">
                        Accede a la store haciendo clic en el botón iOS o
                        Android y descarga la app. Una vez instalada podrás
                        descargar los módulos que te más te interesen.
                    </Text>
                    <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 md:mx-24">
                        {ios && (
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={ios}
                                className="items-center rounded-lg border-4 border-ccyan py-5 text-center text-2xl font-semibold text-ccyan opacity-75 duration-300 hover:bg-ccyan hover:text-white"
                            >
                                <AiOutlineApple className="mr-5 inline h-12 w-12" />
                                iOS
                            </a>
                        )}

                        {android && (
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={android}
                                className="items-center rounded-lg border-4 border-cpurple py-5 text-center text-2xl font-semibold text-cpurple opacity-75 duration-300 hover:bg-cpurple hover:text-white"
                            >
                                <AiOutlineAndroid className="mr-5 inline h-12 w-12" />
                                Android
                            </a>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default DownloadApp;
